"use client";

import { c as _c } from "react/compiler-runtime";
import { FiPackage, FiBarChart2 } from "react-icons/fi";
const Accessibility = t0 => {
  const $ = _c(95);
  const {
    accessibilityScore,
    accessibilityCategory,
    handleAccessibilityChange,
    productName,
    onBack,
    onNext
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiPackage className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Accessibility</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = productName || "this product";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-1 sm:mb-2">How would you rate the accessibility of <span className="font-semibold">{t2}</span> for your patients?</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-[10px] sm:text-xs text-gray-500 font-poppins mb-4 sm:mb-6">e.g., insurance coverage, prior auth ease, supply chain availability</p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== handleAccessibilityChange) {
    t5 = e => handleAccessibilityChange(Number(e.target.value));
    $[4] = handleAccessibilityChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = accessibilityScore <= 0 ? "#E0E0E0" : accessibilityScore <= 25 ? `linear-gradient(to right, #F59E0B 0%, #F59E0B ${accessibilityScore}%, #E0E0E0 ${accessibilityScore}%, #E0E0E0 100%)` : accessibilityScore <= 50 ? `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #6A5ACD ${accessibilityScore}%, #E0E0E0 ${accessibilityScore}%, #E0E0E0 100%)` : accessibilityScore <= 75 ? `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #1E5EFF 50%, #1E5EFF ${accessibilityScore}%, #E0E0E0 ${accessibilityScore}%, #E0E0E0 100%)` : `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #1E5EFF 50%, #00BE52 75%, #00BE52 ${accessibilityScore}%, #E0E0E0 ${accessibilityScore}%, #E0E0E0 100%)`;
  let t7;
  if ($[6] !== t6) {
    t7 = {
      background: t6
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== accessibilityScore || $[9] !== t5 || $[10] !== t7) {
    t8 = <input type="range" min="0" max="100" step="1" value={accessibilityScore} onChange={t5} className="w-full h-2 rounded-full appearance-none cursor-pointer confidence-slider" style={t7} />;
    $[8] = accessibilityScore;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== handleAccessibilityChange) {
    t9 = () => handleAccessibilityChange(0);
    $[12] = handleAccessibilityChange;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = accessibilityScore === 0 ? "#1E5EFF" : "#A0A0A0";
  let t11;
  if ($[14] !== t10) {
    t11 = {
      color: t10
    };
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="font-medium">0</div>;
    t13 = <div className="text-[8px] sm:text-[10px]">Very Poor</div>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11 || $[19] !== t9) {
    t14 = <button type="button" onClick={t9} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t11}>{t12}{t13}</button>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== handleAccessibilityChange) {
    t15 = () => handleAccessibilityChange(25);
    $[21] = handleAccessibilityChange;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = accessibilityScore === 25 ? "#1E5EFF" : "#A0A0A0";
  let t17;
  if ($[23] !== t16) {
    t17 = {
      color: t16
    };
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  let t19;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="font-medium">25</div>;
    t19 = <div className="text-[8px] sm:text-[10px]">Poor</div>;
    $[25] = t18;
    $[26] = t19;
  } else {
    t18 = $[25];
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t15 || $[28] !== t17) {
    t20 = <button type="button" onClick={t15} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t17}>{t18}{t19}</button>;
    $[27] = t15;
    $[28] = t17;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== handleAccessibilityChange) {
    t21 = () => handleAccessibilityChange(50);
    $[30] = handleAccessibilityChange;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = accessibilityScore === 50 ? "#1E5EFF" : "#A0A0A0";
  let t23;
  if ($[32] !== t22) {
    t23 = {
      color: t22
    };
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  let t25;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="font-medium">50</div>;
    t25 = <div className="text-[8px] sm:text-[10px]">Fair</div>;
    $[34] = t24;
    $[35] = t25;
  } else {
    t24 = $[34];
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t21 || $[37] !== t23) {
    t26 = <button type="button" onClick={t21} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t23}>{t24}{t25}</button>;
    $[36] = t21;
    $[37] = t23;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== handleAccessibilityChange) {
    t27 = () => handleAccessibilityChange(75);
    $[39] = handleAccessibilityChange;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  const t28 = accessibilityScore === 75 ? "#1E5EFF" : "#A0A0A0";
  let t29;
  if ($[41] !== t28) {
    t29 = {
      color: t28
    };
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  let t31;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="font-medium">75</div>;
    t31 = <div className="text-[8px] sm:text-[10px]">Good</div>;
    $[43] = t30;
    $[44] = t31;
  } else {
    t30 = $[43];
    t31 = $[44];
  }
  let t32;
  if ($[45] !== t27 || $[46] !== t29) {
    t32 = <button type="button" onClick={t27} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t29}>{t30}{t31}</button>;
    $[45] = t27;
    $[46] = t29;
    $[47] = t32;
  } else {
    t32 = $[47];
  }
  let t33;
  if ($[48] !== handleAccessibilityChange) {
    t33 = () => handleAccessibilityChange(100);
    $[48] = handleAccessibilityChange;
    $[49] = t33;
  } else {
    t33 = $[49];
  }
  const t34 = accessibilityScore === 100 ? "#1E5EFF" : "#A0A0A0";
  let t35;
  if ($[50] !== t34) {
    t35 = {
      color: t34
    };
    $[50] = t34;
    $[51] = t35;
  } else {
    t35 = $[51];
  }
  let t36;
  let t37;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="font-medium">100</div>;
    t37 = <div className="text-[8px] sm:text-[10px]">Excellent</div>;
    $[52] = t36;
    $[53] = t37;
  } else {
    t36 = $[52];
    t37 = $[53];
  }
  let t38;
  if ($[54] !== t33 || $[55] !== t35) {
    t38 = <button type="button" onClick={t33} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t35}>{t36}{t37}</button>;
    $[54] = t33;
    $[55] = t35;
    $[56] = t38;
  } else {
    t38 = $[56];
  }
  let t39;
  if ($[57] !== t14 || $[58] !== t20 || $[59] !== t26 || $[60] !== t32 || $[61] !== t38) {
    t39 = <div className="flex justify-between mt-2 text-[10px] sm:text-xs font-poppins">{t14}{t20}{t26}{t32}{t38}</div>;
    $[57] = t14;
    $[58] = t20;
    $[59] = t26;
    $[60] = t32;
    $[61] = t38;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  let t40;
  if ($[63] !== t39 || $[64] !== t8) {
    t40 = <div className="mb-4"><div className="relative">{t8}{t39}</div></div>;
    $[63] = t39;
    $[64] = t8;
    $[65] = t40;
  } else {
    t40 = $[65];
  }
  const t41 = accessibilityScore < 20 ? "#F59E0B" : accessibilityScore < 50 ? "#6A5ACD" : accessibilityScore < 75 ? "#1E5EFF" : "#00BE52";
  let t42;
  if ($[66] !== t41) {
    t42 = {
      color: t41
    };
    $[66] = t41;
    $[67] = t42;
  } else {
    t42 = $[67];
  }
  let t43;
  if ($[68] !== accessibilityScore || $[69] !== t42) {
    t43 = <div className="text-2xl sm:text-3xl font-bold font-poppins" style={t42}>{accessibilityScore}%</div>;
    $[68] = accessibilityScore;
    $[69] = t42;
    $[70] = t43;
  } else {
    t43 = $[70];
  }
  const t44 = accessibilityScore < 20 ? "#F59E0B" : accessibilityScore < 50 ? "#6A5ACD" : accessibilityScore < 75 ? "#1E5EFF" : "#00BE52";
  let t45;
  if ($[71] !== t44) {
    t45 = {
      backgroundColor: t44
    };
    $[71] = t44;
    $[72] = t45;
  } else {
    t45 = $[72];
  }
  let t46;
  if ($[73] !== accessibilityCategory || $[74] !== t45) {
    t46 = <span className="inline-flex items-center px-2 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-xs font-bold font-poppins text-white rounded-full shadow-sm" style={t45}>{accessibilityCategory}</span>;
    $[73] = accessibilityCategory;
    $[74] = t45;
    $[75] = t46;
  } else {
    t46 = $[75];
  }
  let t47;
  if ($[76] !== t43 || $[77] !== t46) {
    t47 = <div className="flex items-end justify-end mt-4 sm:mt-0"><div className="flex flex-col items-end gap-1 sm:gap-2">{t43}{t46}</div></div>;
    $[76] = t43;
    $[77] = t46;
    $[78] = t47;
  } else {
    t47 = $[78];
  }
  let t48;
  if ($[79] !== t40 || $[80] !== t47) {
    t48 = <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-5">{t40}{t47}</div>;
    $[79] = t40;
    $[80] = t47;
    $[81] = t48;
  } else {
    t48 = $[81];
  }
  let t49;
  if ($[82] !== t3 || $[83] !== t48) {
    t49 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t1}{t3}{t4}{t48}</div></div>;
    $[82] = t3;
    $[83] = t48;
    $[84] = t49;
  } else {
    t49 = $[84];
  }
  let t50;
  if ($[85] !== onBack) {
    t50 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[85] = onBack;
    $[86] = t50;
  } else {
    t50 = $[86];
  }
  let t51;
  if ($[87] !== onNext) {
    t51 = <button onClick={onNext} className="flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]">Next</button>;
    $[87] = onNext;
    $[88] = t51;
  } else {
    t51 = $[88];
  }
  let t52;
  if ($[89] !== t50 || $[90] !== t51) {
    t52 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t50}{t51}</div>;
    $[89] = t50;
    $[90] = t51;
    $[91] = t52;
  } else {
    t52 = $[91];
  }
  let t53;
  if ($[92] !== t49 || $[93] !== t52) {
    t53 = <>{t49}{t52}</>;
    $[92] = t49;
    $[93] = t52;
    $[94] = t53;
  } else {
    t53 = $[94];
  }
  return t53;
};
export default Accessibility;